define('OutSystems/ReactWidgets/ButtonGroupItem',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ButtonGroupItem = void 0;
    var ButtonGroupItem = (function (_super) {
        tslib_1.__extends(ButtonGroupItem, _super);
        function ButtonGroupItem() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ButtonGroupItem.prototype.handleClick = function (event) {
            var _this = this;
            this.executeWithActiveClassOn(function () { return _this.props.updateValueInParent(_this.props.value); });
        };
        ButtonGroupItem.prototype.render = function () {
            var _this = this;
            var buttonGroupItemAttributes = {
                "data-button-group-item": "",
                className: this.props.style + (this.props.isSelected ? " button-group-selected-item" : ""),
                disabled: !this.props.enabled,
                "aria-checked": "".concat(this.props.isSelected),
                role: "radio",
                onClick: function (event) { return _this.handleClick(event); },
            };
            this.fillWithBuiltinProperties(buttonGroupItemAttributes);
            return React.createElement("button", tslib_1.__assign({}, buttonGroupItemAttributes), this.props.children);
        };
        ButtonGroupItem = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], ButtonGroupItem);
        return ButtonGroupItem;
    }(Widget_1.Widget));
    exports.ButtonGroupItem = ButtonGroupItem;
});
//# sourceMappingURL=ButtonGroupItem.js.map;
